import contractsRepository from './repositories/projects/contractsRepository';

export default {
    projects: {
        contracts: contractsRepository,
    },
};
